module.exports = __webpack_public_path__ + "img/zk-icon-pending-order.10e47f1c.svg";